import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const SITE_ID_LS_KEY = 'transport.site_id';

export function getStoredSiteId() {
  return localStorage.getItem(SITE_ID_LS_KEY);
}

export function useSiteId() {
  const { siteId } = useParams();

  useEffect(() => {
    const storedSiteId = getStoredSiteId();

    if (siteId && storedSiteId !== siteId) {
      localStorage.setItem(SITE_ID_LS_KEY, siteId);
    }
  }, [siteId]);

  return siteId;
}
